import { Share } from '@capacitor/share';
import { isNativeApp } from './appLinks';

type SharePayload = {
  url: string;
  title?: string;
  text?: string;
};

export type ShareMethod = 'native' | 'web' | 'clipboard' | 'none';

const canUseWebShare = (): boolean => {
  return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
};

const canUseClipboard = (): boolean => {
  return typeof navigator !== 'undefined' && !!navigator.clipboard?.writeText;
};

export const shareLink = async ({ url, title, text }: SharePayload): Promise<ShareMethod> => {
  if (!url) return 'none';
  if (isNativeApp()) {
    try {
      await Share.share({
        url,
        title,
        text,
        dialogTitle: title || text,
      });
      return 'native';
    } catch {
      // fall through to web share / clipboard
    }
  }
  if (canUseWebShare()) {
    try {
      await navigator.share({ url, title, text });
      return 'web';
    } catch {
      // fall through to clipboard
    }
  }
  if (canUseClipboard()) {
    await navigator.clipboard.writeText(url);
    return 'clipboard';
  }
  return 'none';
};
